module.exports = __webpack_public_path__ + "static/media/course_03.73c12114.png";